import type { LatLngExpression } from "leaflet";

import type { Country } from "./company.js";
import type { Organization } from "./planting.js";

export type Count = {
	ordered: number;
	planted: number;
	designated: number;
};

export type Impacts = Impact[];

/** Represents a single impact category. */
export type Impact = {
	/** The name of the impact category. */
	slug: string;
	/** The icon to display for the impact category. */
	icon: string | { src: string };
	/** The primary text to display for the impact category. (ex. "Trees Planted") */
	primary: string;
	/**
	 * The secondary text to display for the impact category. (ex. "Compares to
	 * 1000 trees in a forest")
	 */
	secondary: string;
	/** The count of the impact category. (ex. 1000) */
	count: number;
	/** The units of the impact category. (ex. "kg") */
	units?: string;
	secondaryValue: string;
};

export type CleanedCompanyData = {
	impacts: Impacts;
	treesByForestTypes: ForestType[];
	countries: Country[];
	trees: Count;
};

export type ForestType = {
	id: number;
	name: string;
} & Count;

export type CountryPlantingData = {
	id: number;
	name: string;
	lat: string;
	long: string;
	regions: RegionPlantingData[];
};

export type RegionPlantingData = {
	id: number;
	name: string;
	lat: number | null;
	long: number | null;
	organization: Organization;
	subSites: SubSite[];
};

export type SubSite = {
	id: number;
	name: string;
	description: string;
	geofence?: {
		type: string;
		coordinates: LatLngExpression[][][];
	};
	manager: {
		name: string;
		title: string;
	};
	type: "Trees" | "Kelp";
	forestType: {
		id: number;
		name: string;
	};
	numberOfPlanters: number;
	image: string | null;
	area: number;
	counts: Count;
};

export type CleanedPlantingData = CountryPlantingData[];

export const impacts = {
	workingDays: "working_days",
	co2: "co2",
	areaPlanted: "area_planted",
	yield: "yield",
	oceanAreaPlanted: "ocean_area_planted",
} as const;
